import {connect} from "react-redux"
import React, {Component} from "react"
import styled from "styled-components"
import {SettlementForm, SettlementPadding} from "manager/views/components/Settlement/Common/SettlementCard"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"
import {createStructuredSelector} from "reselect"
import {
  selectAgentOpId,
  selectAssignmentTransactionHash,
  selectPlaceQualiaOrderError,
  selectSelectedSettlementProviderName,
  selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {Grid, GridCell} from "manager/views/components/Settlement/Common/Grid"
import {
  InputContainer,
  Label,
  SettlementInput,
  SettlementSelect
} from "manager/views/components/Settlement/Common/Input"
import {selectPlaceOrderDefaults} from "manager/selectors/settlement_provider_search_selectors"
import {fetchSettlementProviderPlaceOrderDefaults} from "manager/redux/settlement_provider_search"
import FooterContainer from "manager/views/components/Settlement/Common/FooterContainer"
import {placeQualiaOrder, resetPlaceQualiaOrderError} from "manager/redux/referral"
import SettlementFormHr from "manager/views/components/Settlement/Common/SettlementFormHr"
import _ from "lodash"
import SettlementDatePicker from "manager/views/components/Settlement/Common/SettlementDatePicker"
import RedToast from "manager/views/components/Settlement/Common/RedToast"
import BackLink from "manager/views/components/Settlement/Common/BackLink"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"
import OpCheckbox from 'common/views/components/OpCheckbox'
import {isPast, parse} from 'date-fns'
import {segmentEventTracker} from "common/analytics"
import {fromCurrency, toCurrency} from "manager/util/helper"
import {US_STATES} from "manager/common/src/constants"
import AuthorizeQualiaLegalese from "manager/views/components/ReferralStatus/Common/AuthorizeQualiaLegalese"

const PlaceOrderContainer = styled(SettlementForm)`
  display: flex;
  flex-direction: column;
`

const Subsection = styled(SettlementPadding)`
`

const TermsSubsection = styled(Subsection)`
  display: flex;
  padding-bottom: 40px;
`

const TermText = styled.div`
  font-size: 12px;
  line-height: 17px;
  font-weight: 300;
  letter-spacing: 0;
`

const H1 = styled.h1`
  margin-top: 24px;
  margin-bottom: 28px;
  font-size: 26px;
  font-weight: bold;
  line-height: 33px;
`

const H2 = styled.h2`
  margin-top: 0;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  letter-spacing: 0;
  margin-bottom: 15px;
`

const ProviderName = styled.div`
  color: #4A4A4A;
  font-size: 20px;
  line-height: 25px;
  font-weight: bold;
  letter-spacing: 0;
  margin-bottom: 16px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    margin-bottom: 20px;
  }
`

class PlaceOrder extends Component {

  state = {
    canSave: false,
    formValues: {
      initialized: false,
      address_line_1: null,
      address_line_2: null,
      city: null,
      state: null,
      zipcode: null,
      purchase_price: null,
      mls_number: null,
      consumer_first_name: null,
      consumer_last_name: null,
      consumer_email: null,
      broker_name: null,
      agent_first_name: null,
      agent_last_name: null,
      agent_email: null,
      expected_close_date: null,
      terms_accepted: false
    },
    dateError: false
  }

  componentDidMount() {
    const {hash, fetchSettlementProviderPlaceOrderDefaults} = this.props
    if (hash) {
      fetchSettlementProviderPlaceOrderDefaults(hash)
    }
    segmentEventTracker("Place-Order-Input Viewed", {'transaction_op_id': this.props.transaction_op_id, 'agent_op_id': this.props.agent_op_id})
  }

  componentWillUnmount() {
    this.props.resetPlaceQualiaOrderError()
  }

  setFormValue = (key, value) => {
    if (key === "expected_close_date") {
      this.setState({ dateError: isPast(parse(value)) })
    }
    if (key === "purchase_price") {
      value = fromCurrency(value)
    }
    this.setState({ formValues: { ...this.state.formValues, [key]: value} }, this.recalculateSaveMode);
  }

  acceptTerms = () => {
    this.setState(prevState => {
      this.setFormValue('terms_accepted', !prevState.formValues.terms_accepted)
    })
  }

  handleOnChange = (field) => {
    return (event) => {
      const value = event && event.target && event.target.value
      if (value !== undefined) {
        if(field === 'zipcode' && value.length > 5) {
          event.preventDefault()
        } else {
          this.setFormValue(field, value)
        }
      }
      if (field === 'state' && event && event.value && event.label) {
        this.setFormValue(field, event.value)
      }
    }
  }

  handleOnKeyPress = (event) => {
    // input type="number" allows e, -, and .
    if (event.key === 'e' || event.key === '-' || event.key === '.'){
      event.preventDefault()
    }
  }

  recalculateSaveMode = () => {
    const optionalFormKeys = ['address_line_2']
    let canSave = _.every(this.state.formValues, (val, key) => optionalFormKeys.includes(key) || (val && (!val.trim || val.trim())))
    canSave = canSave && !this.state.dateError
    this.setState({canSave})
  }

  setStateValue = () => {
    let currentState = this.state.formValues.state
    if (!currentState) {
      return
    }

    let selectedState = US_STATES.filter((state) => {
      if (state.value.toLowerCase() === currentState.toLowerCase() || state.label.toLowerCase() === currentState.toLowerCase()){
        return state
      }
    })
    if (selectedState.length > 0){
      this.setState({ formValues: { ...this.state.formValues, state: selectedState[0].value} });
    }
  }

  placeOrder = _.debounce(async () => {
    const {placeQualiaOrder, hash, transaction_op_id, agent_op_id} = this.props

    const request = {
      transaction_hash: hash,
      ...this.state.formValues
    }

    let isPlaceOrderSuccessful = false
    try {
      this.setState({canSave:false})
      isPlaceOrderSuccessful = await placeQualiaOrder(hash, request)
    } finally {
      this.recalculateSaveMode()
    }
    if (isPlaceOrderSuccessful) {
      segmentEventTracker('Order Placed', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
      this.props.onClose()
    }
  })

  componentWillReceiveProps(nextProps) {
    const {placeOrderDefaults} = nextProps
    const {initialized} = this.state.formValues
    if (placeOrderDefaults && !initialized) {
      this.setState(
        { formValues: { ...this.state.formValues, initialized: true, ...placeOrderDefaults } },
        this.setStateValue,
        this.recalculateSaveMode
      );
    }
  }

  render() {
    const {selectedSettlementProviderName, placeQualiaOrderError, onClose, openUrlFeatureEnabled} = this.props

    const {
      canSave, dateError
    } = this.state

    const {
      address_line_1, address_line_2, city, state, zipcode, purchase_price, mls_number, consumer_first_name,
      consumer_last_name, consumer_email, broker_name, agent_first_name, agent_last_name, agent_email, expected_close_date,
      terms_accepted
    } = this.state.formValues

    return (
      <SettlementMaxWidth>
        {placeQualiaOrderError && <RedToast errorMessage="Failed to place order. Please check your connection and try again."/>}
        <BackLink onClick={onClose}/>
        <PlaceOrderContainer>
          <Subsection paddingRight='83px'>
            <H1>Place Order</H1>
            <Label marginBottom="4px">Provider Name</Label>
            <ProviderName>{selectedSettlementProviderName}</ProviderName>
          </Subsection>
          <SettlementFormHr marginBottom="15px" />
          <Subsection paddingRight='83px'>
            <H2>Property Address</H2>
            <Grid>
              <GridCell>
                <SettlementInput label={"Address*"} value={address_line_1} onChange={this.handleOnChange("address_line_1")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Apt, Suite, Other"} value={address_line_2} onChange={this.handleOnChange("address_line_2")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"City*"} value={city} onChange={this.handleOnChange("city")}/>
              </GridCell>
              <GridCell>
                <SettlementSelect label={"State*"} value={state} onChange={this.handleOnChange("state")} options={US_STATES}/>
                <SettlementInput label={"Zip Code*"} value={zipcode} type="number" hideArrows={true} onChange={this.handleOnChange("zipcode")} onKeyPress={this.handleOnKeyPress}/>
              </GridCell>
            </Grid>
          </Subsection>
          <SettlementFormHr marginBottom="15px" />
          <Subsection paddingRight='83px'>
            <H2>Order Details</H2>
            <Grid>
              <GridCell>
                <SettlementInput label={"Purchase Price*"}
                                 value={toCurrency(purchase_price)}
                                 pattern={"$([0-9]+,)*"}
                                 onChange={this.handleOnChange("purchase_price")}/>
                <SettlementInput label={"MLS Number*"} value={mls_number} onChange={this.handleOnChange("mls_number")}/>
              </GridCell>
              <GridCell>
                <InputContainer>
                  <Label>{"Expected Close Date*"}</Label>
                  <SettlementDatePicker value={expected_close_date}
                                        onChange={date => this.setFormValue('expected_close_date', date)}
                                        errorMsg={dateError && "Please select a date in the future."}/>
                </InputContainer>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Referral First Name*"} value={consumer_first_name} onChange={this.handleOnChange("consumer_first_name")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Referral Last Name*"} value={consumer_last_name} onChange={this.handleOnChange("consumer_last_name")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Referral Email*"}
                                 value={consumer_email}
                                 type="email"
                                 onChange={this.handleOnChange("consumer_email")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Brokerage*"} value={broker_name} onChange={this.handleOnChange("broker_name")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Agent First Name*"} value={agent_first_name} onChange={this.handleOnChange("agent_first_name")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Agent Last Name*"} value={agent_last_name} onChange={this.handleOnChange("agent_last_name")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Agent Email*"}
                                 value={agent_email}
                                 type="email"
                                 onChange={this.handleOnChange("agent_email")}/>
              </GridCell>
            </Grid>
          </Subsection>
          <TermsSubsection paddingRight='83px'>
            <OpCheckbox checked={terms_accepted} onChange={this.acceptTerms}/>
            <TermText>
              <span>{`I understand I will be sending the provided information on behalf of my client to ${selectedSettlementProviderName}.`}</span>
              <AuthorizeQualiaLegalese/>
            </TermText>
          </TermsSubsection>
          <SettlementFormHr/>
          <FooterContainer cancelOnClick={onClose}
                           buttonName="Place Order"
                           disabled={!canSave}
                           buttonOnClick={this.placeOrder}/>
        </PlaceOrderContainer>
      </SettlementMaxWidth>
    )
  }

}

const selector = createStructuredSelector({
  hash: selectAssignmentTransactionHash,
  selectedSettlementProviderName: selectSelectedSettlementProviderName,
  placeOrderDefaults: selectPlaceOrderDefaults,
  placeQualiaOrderError: selectPlaceQualiaOrderError,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

const actions = {
  placeQualiaOrder,
  resetPlaceQualiaOrderError,
  fetchSettlementProviderPlaceOrderDefaults,
}

export default connect(selector, actions)(PlaceOrder)
